import { Component, OnInit } from '@angular/core';
import {Message} from "primeng/primeng";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {OrdenCompraService} from "../Services/ordenCompra.service";
import {Producto} from "../producto/producto";
import {TiendaService} from "../Services/tienda.service";
import {Tienda} from "../tienda/tienda";
import {InventarioService} from "../Services/inventario.service";
import {Inventario} from "../inventario/inventario";
import {OrdenCompra} from "./ordenCompra";
import {OrdenCompraDetalle} from "./ordenCompraDetalle";
import {ProvedorService} from "../Services/provedor.service";
import {Provedor} from "../provedor/provedor";
import {ProductoService} from "../Services/producto.service";

@Component({
  selector: 'app-ordenCompra',
  templateUrl: './orden-compra.component.html',
  styleUrls: ['./orden-compra.component.css']
})
export class OrdenCompraComponent implements OnInit {


  msgs: Message[] = [];
  formOrdenCompra : FormGroup;
  formProducto: FormGroup;
  formPago: FormGroup;
  btnNuevo = true;
  btnCancelar = false;
  btnGuardar = false;
  btnGuardarEditar = false;

  btnNuevoProducto = true;
  btnCancelarProducto = false;
  btnGuardarProducto = false;
  btnGuardarEditarProducto = false;

  btnNuevoPago = true;
  btnCancelarPago = false;
  btnGuardarPago = false;
  btnGuardarEditarPago = false;

  btnGuardarComentario = false;
  panelRequeridos = false;
  loading = false;
  OrdenComprasRegistrados:OrdenCompra[];
  OrdenCompraSeleccionado:OrdenCompra;
  tipoGuardado = '';
  ProductosRegistrados:Inventario[];
  ProductosOrdenCompra : Inventario[] = [];
  cantidad = '';
  TiendasRegistrados:Tienda[];
  DetalleOrdenComprasRegistrados:OrdenCompraDetalle[];
  verDetalleOrdenCompra = false;
  lista = new Object();
  verPreOrdenCompra = false;
  ProvedorsRegistrados:Provedor[];
  verOrdenFinal = false;
  vrUnitario = 0;
  cantidadItems = 0;
  verEdicionCantidad = false;
  verInventario = false;
  verAddProducto = false;
  verPagosODC = false;
  pagosOrden:any[];

  constructor(private servicioProvedor:ProvedorService,
              private servicioInventario:InventarioService,
              private servicioOrdenCompra:OrdenCompraService,
              private fb: FormBuilder,private  servicioTienda:TiendaService,
              private servicioProducto:ProductoService) { }

  ngOnInit() {
    this.crearControlesOrdenCompra();
    this.crearControlesProducto();
    this.crearControlesPago();
    this.CancelarPago();
    this.Cancelar();
    this.CancelarProducto();
    this.listarOrdenCompras();
    this.listarProvedors();
    this.listarTiendas();
  }
  crearControlesPago(){
    this.formPago = this.fb.group({
        ordenCompra_id:[''],
        valor:['',Validators.required],
      }
    );

  }
  crearControlesProducto(){
    this.formProducto = this.fb.group({
        nombre:['',Validators.required],
        categoria_id:['',Validators.required],
        unidad:['',Validators.required],
        precioCompra:['',Validators.required],
        precioVenta:['',Validators.required],
        stockMinimo:['',Validators.required],
        stockMaximo:['',Validators.required],
        marca:['',Validators.required],
        estado:[''],
        codigoBarra:['0',Validators.required],
        dimension:[''],
        presentacion:[''],
        color:[''],
        fechaVencimiento:[''],
        impuesto:[''],
        ubicacion:[''],
        imagen:[''],
        talla:[''],

      }
    );

  }
  crearControlesOrdenCompra(){
    this.formOrdenCompra = this.fb.group({
      tienda_id:[''],
      proveedor_id:[''],
      usuario_id:[''],
      valorTotal :[''],
      metodoPago :[''],
      estado :[''],
      estadoPago :[''],
      observaciones  :['']
      }
    );

  }
  nuevoOrdenCompra(){
    this.btnNuevo = false;
    this.btnGuardar = true;
    this.btnGuardarEditar = false;
    this.btnCancelar = true;
    this.formOrdenCompra.enable();
    this.formOrdenCompra.reset();
    this.panelRequeridos = true;
    this.tipoGuardado = 'guardar';

  }
  nuevoProducto(){
    this.btnNuevoProducto = false;
    this.btnGuardarProducto = true;
    this.btnGuardarEditarProducto = false;
    this.btnCancelarProducto = true;
    this.formProducto.enable();
    this.formProducto.reset();
  }
  nuevoPago(){
    this.btnNuevoPago = false;
    this.btnGuardarPago = true;
    this.btnGuardarEditarPago = false;
    this.btnCancelarPago = true;
    this.formPago.enable();
    this.formPago.reset();
  }
  Cancelar(){
    this.btnGuardar = false;
    this.btnNuevo = true;
    this.btnCancelar = false;
    this.btnGuardarEditar = false;
    this.formOrdenCompra.reset();
    this.formOrdenCompra.disable();
    this.panelRequeridos = false;
    this.verOrdenFinal = false;
    this.verInventario = false;
  }
  CancelarPago(){
    this.btnGuardarPago = false;
    this.btnNuevoPago = true;
    this.btnCancelarPago = false;
    this.btnGuardarEditarPago = false;
    this.formPago.reset();
    this.formPago.disable();
  }
  CancelarProducto(){
    this.btnGuardarProducto = false;
    this.btnNuevoProducto = true;
    this.btnCancelarProducto = false;
    this.btnGuardarEditarProducto = false;
    this.formProducto.reset();
    this.formProducto.disable();
  }
  mensajes(severity,summary,detail){
    this.msgs = [];
    this.msgs.push({severity:severity, summary:summary, detail:detail});
  }
  listarOrdenCompras(){
    this.loading = true;
    this.servicioOrdenCompra.getOrdenCompra()
      .subscribe(
        rt => {
          this.OrdenComprasRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  guardarNuevoOrdenCompra(){
    if(this.tipoGuardado == 'editar'){
      this.loading = true;
      this.servicioOrdenCompra.putOrdenCompra(this.formOrdenCompra.value,this.OrdenCompraSeleccionado.id)
        .subscribe(
          rt => {
            this.mensajes('success','Actualizacion',rt);
            this.listarOrdenCompras();
            this.loading = false;
          },
          er => this.mensajes('error','Error',er),
          () =>  {
            this.Cancelar();
          });
    }
    else if(this.tipoGuardado == 'guardar') {
      this.loading = true;
      console.log(this.formOrdenCompra.value);
      this.servicioOrdenCompra.addOrdenCompra(this.formOrdenCompra.value)
        .subscribe(
          rt => {
            this.mensajes('success','Guardar',rt);
            this.listarOrdenCompras();
            this.loading = false;
          },
          er => this.mensajes('error','Error',er),
          () =>  {
            this.Cancelar();
          });
    }
    this.tipoGuardado = '';
  }
  listarDetalleOrdenCompras(){
    this.loading = true;
    this.servicioOrdenCompra.getDetallesByOrden(this.OrdenCompraSeleccionado.id)
      .subscribe(
        rt => {
          this.DetalleOrdenComprasRegistrados = rt;
          if(rt.length != 0){
            this.verPreOrdenCompra = false;
            this.verOrdenFinal = true;
          }else {
            this.verPreOrdenCompra = true;
            this.verInventario = true;
          }

          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  seleccionarOrdenCompra(item:OrdenCompra){
    this.btnNuevo = false;
    this.btnGuardar = false;
    this.btnGuardarEditar = true;
    this.btnCancelar = true;
    this.formOrdenCompra.enable();
    this.panelRequeridos = true;
    this.OrdenCompraSeleccionado = item;
    this.OrdenCompraDetalle(item);
    this.listarDetalleOrdenCompras();
    this.listarProductos();
    this.verDetalleOrdenCompra = true;
    this.tipoGuardado = 'editar';

  }
  OrdenCompraDetalle(item:OrdenCompra):void {
    this.formOrdenCompra.patchValue({
      id:item.id,
      proveedor_id:item.proveedor_id,
      usuario_id:item.usuario_id,
      valorTotal:item.valorTotal,
      metodoPago:item.metodoPago,
      estado:item.estado,
      estadoPago:item.estadoPago,
      tienda_id:item.tienda_id,
      observaciones:item.observaciones,

    });
  }
  listarProductos(){
    this.loading = true;
    this.servicioInventario.getInventarioByTienda(this.OrdenCompraSeleccionado.tienda_id)
      .subscribe(
        rt => {
          console.log(rt);
          this.ProductosRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  Mover(item:Inventario){
    if(item['cantidadItems']){
      let prod = [...this.ProductosOrdenCompra];
      item['cantidad'] = item['cantidadItems'];
      item['ordenCompra_id'] = this.OrdenCompraSeleccionado.id;
      item['producto_id'] = item.producto_id;
      item['precioUnitario'] = this.vrUnitario;
      item['total'] = item['vrUnitario'] * parseFloat(item['cantidadItems']);
      prod.push(item);
      this.ProductosOrdenCompra = prod;
      this.verPreOrdenCompra = true;
    }else {
      alert('Antes de agregar un producto debe escribir una cantidad');
    }

  }
  BorrarProdOrdenCompra(item:Producto){
    let prod = [...this.ProductosOrdenCompra];
    let indice = prod.indexOf(item);
    prod.splice(indice,1);
    this.ProductosOrdenCompra = prod;
  }
  generarOrdenCompra(){
    let opcion = confirm('Esta seguro de de efectuar esta Orden de Compra, esto no puede deshacerse');
    if(opcion){
      this.loading = true;
      let OrdenCompras = {productos:this.ProductosOrdenCompra,ordenCompra_id:this.OrdenCompraSeleccionado.id};
      this.servicioOrdenCompra.addDetalleOrdenCompra(OrdenCompras)
        .subscribe(
          rt => {
            console.log(rt);
            this.mensajes('success','Guardar',rt);
            this.listarOrdenCompras();
            this.listarDetalleOrdenCompras();
            this.listarProductos();
            this.loading = false;
          },
          er => {
            this.mensajes('error','Error',er);
            this.loading = false;
          },
          () =>  {
            this.verPreOrdenCompra = false;
            this.verOrdenFinal = true;
            this.verInventario = false;
          });
    }

  }
  listarProvedors(){
    this.loading = true;
    this.servicioProvedor.getProvedor()
      .subscribe(
        rt => {
          this.ProvedorsRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  listarTiendas(){
    this.loading = true;
    this.servicioTienda.getTienda()
      .subscribe(
        rt => {
          console.log(rt);
          this.TiendasRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  guardarNuevoProducto(){
      this.loading = true;
      this.servicioProducto.addProducto(this.formProducto.value)
        .subscribe(
          rt => {
            this.mensajes('success','Guardar',rt);
            this.loading = false;
          },
          er => {
            this.mensajes('error','Error',er);
            this.loading = false;
          },
          () =>  {
            this.CancelarProducto();
          });
  }
  addProdyucto(){
    this.verAddProducto = true;
  }
  PagoOrdenCompra(){
    this.loading = true;
    this.formPago.patchValue({
      ordenCompra_id:this.OrdenCompraSeleccionado.id
    });
    this.servicioOrdenCompra.addPagoOrdenCompra(this.formPago.value)
      .subscribe(
        rt => {
          this.mensajes('success','Guardar',rt);
          this.listarPagos(this.OrdenCompraSeleccionado);
          this.listarOrdenCompras();
          this.loading = false;
        },
        er => {
          this.mensajes('error','Error',er);
          this.loading = false;
        },
        () =>  {
          this.CancelarProducto();
        });
  }
  RecepcionProductos(item:OrdenCompraDetalle){
        let cantPend = parseFloat(item.cantidadPendiente) - parseFloat(item.cantidadRecibida);
        if(cantPend >= 0){
          let producto = new Object();
          producto['cantidadRecibida'] = parseFloat(item.cantidadRecibida);
          this.loading = true;
          this.servicioOrdenCompra.putDetalleOrdenCompra(producto,item.id)
            .subscribe(
              rt => {
                this.mensajes('success','Actualizacion',rt);
                this.listarDetalleOrdenCompras();
                this.loading = false;
              },
              er => this.mensajes('error','Error',er),
              () =>  {
                this.verEdicionCantidad = false;
              });
        }else {
          this.mensajes('warn','Antencion','La cantidad a recibir debe ser menor a la cantidad pendiente.');
        }
  }
  ImprimirOrdenCompra(item:OrdenCompra){
    let url = 'https://api.appvinta.com/ordencompra/imprimir/'+item.id;
    window.open(url,'blank');
  }
  CerrarProducto(item:any){
    item.cantidadPendiente = 0;

  }
  listarPagos(item){
    this.OrdenCompraSeleccionado = item;
    this.loading = true;
    this.servicioOrdenCompra.getPagosByOrden(item.id)
      .subscribe(
        rt => {
          this.pagosOrden = rt;
          this.verPagosODC = true;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/orden-compra/orden-compra.component.ts